// @flow
import React, { type Node } from 'react';

import SimpleDate from 'app/dataProviders/SimpleDate';
import PlainNav, { NavItem } from 'app/common/ui/PlainNav';

import type { Period } from './usePeriods';
import useMonths from './useMonths';


type Props = {
  className?: string,
  period: Period | null,
  date: SimpleDate,
  createPath: ({ date?: SimpleDate, summary: boolean }) => string
}

const MenuLineMonths = ({ className, period, date, createPath }: Props): Node => {
  const months = useMonths(period, date, createPath);

  return (
    <PlainNav className={className}>
      {months.map(({ title, link, current }) => (
        <NavItem key={title} to={link} active={current}>
          {title}
        </NavItem>
      ))}
    </PlainNav>
  );
};

export default MenuLineMonths;
